<template>
    <MainComponent :id="anchorsPageProfile.categoriesSection" data-testid="categories-section">
        <template #title>
            <h2>{{ t('profile.section.categories.title') }}</h2>
        </template>

        <template v-if="profile?.editMode" #title-action>
            <ClientOnly>
                <VJoyIconButton
                    variant="ghost"
                    icon="pen"
                    size="small"
                    :label="$t('general.edit')"
                    data-testid="categories-section-edit-cta"
                    @click="goToEditCategories"
                />
                <template #fallback>
                    <SectionActionSkeleton />
                </template>
            </ClientOnly>
        </template>

        <template v-if="profile && families.length" #content>
            <ul class="categories-section__families" data-testid="categories-section-families">
                <li v-for="family in families" :key="family.id" data-testid="categories-section-family">
                    <FamilyWithCategories :family="family" />
                </li>
            </ul>
        </template>
    </MainComponent>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import {VJoyIconButton} from '@maltjoy/core-vue';
    import MainComponent from '~/components/main/common/MainComponent.vue';
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import {anchorsPageProfile} from '~/config/anchors';
    import {eventBus} from '~/config/events';
    import {EditionOpenedEntryPoint} from '~/config/TrackingEvents';
    import FamilyWithCategories from '~/features/categories/FamilyWithCategories.vue';
    import {useProfileStore} from '~/store/profileStore';
    import {orderedFamilies} from '~/types/domain/Categorization';

    const {t} = useTranslation();
    const {profile} = storeToRefs(useProfileStore());
    const families = computed(() => (profile.value?.categorization ? orderedFamilies(profile.value.categorization) : []));

    function goToEditCategories() {
        eventBus.emit('categories:edit-mode', {entryPoint: EditionOpenedEntryPoint.PROFILE_PAGE});
    }
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .categories-section {
        &__families {
            display: flex;
            flex-wrap: wrap;
            gap: var(--joy-core-spacing-8);
            align-items: flex-start;
            list-style-type: none;
            padding: 0;
            margin: 0;

            @include mq.screen_xxs {
                flex-direction: column;
                gap: var(--joy-core-spacing-4);
            }
        }
    }
</style>
